<template>
  <div v-if="!loading" class="kt-portlet tabs-portlet-container">
    <div class="kt-portlet__head tabs-portlet-head">
      <div class="kt-portlet__head-label">
        <i v-if="icon" :class="[ icon ]" :style="iconStyle" />
        <h3 class="kt-portlet__head-title">
          {{ title }} <small v-if="preCaption"> {{ preCaption }} </small><small v-if="caption" :style="captionStyle">{{ caption }}</small>
        </h3>
      </div>
      <div class="kt-portlet__head-toolbar">
        <ul class="nav nav-tabs nav-tabs-line nav-tabs-line-brand nav-tabs-bold tabs-portlet-tab-headers" role="tablist">
          <li v-for="tab in tabs" :key="tab.name" class="nav-item">
            <a :href="`javascript:void(0);`" class="nav-link"
               :class="{ active: tab.active }"
               @click="() => activateTab(tab.name)">{{ tab.display }}</a>
          </li>
        </ul>
        <div class="tabs-portlet-actions">
          <slot name="_actions" />
        </div>
      </div>
    </div>
    <div class="kt-portlet__body tabs-portlet-body">
      <template v-for="tab in tabs">
        <template v-if="tab.lazy">
          <div v-if="tab.active" :key="tab.name">
            <slot :name="tab.name" />
          </div>
        </template>
        <template v-else>
          <div v-show="tab.active" :key="tab.name">
            <slot :name="tab.name" />
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    caption: {
      type: String,
      required: false,
      default: '',
    },
    icon: {
      type: String,
      required: false,
      default: null,
    },
    iconStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    dataTabs: {
      type: Array,
      required: true,
    },
    preCaption: {
      type: String,
      required: false,
      default: '',
    },
    captionStyle: {
      type: String,
      required: false,
      default: '',
    },
  },
  data: () => ({
    loading: true,
    tabs: [],
  }),
  computed: {
    active_tab() {
      return this.tabs.find(tab => tab.active);
    },
  },
  mounted() {
    this.tabs = this.dataTabs;
    if (!this.tabs.find(tab => tab.active)) {
      this.tabs[0].active = true;
    }
    this.loading = false;
  },
  methods: {
    activateTab(which) {
      // set tabs false
      this.tabs.map(tab => tab.active = false);
      // vue can't detect indexed array element mutation; we have to splice the
      // object out and replace it
      const index = this.tabs.findIndex(tab => tab.name === which);
      this.tabs.splice(index, 1, { ...this.tabs[index], active: true });
      EventBus.$emit('tab-requested', which);
    },
  },

};
</script>

<style lang="scss" scoped>
@use "AssetsSass/_variables" as *;

.tabs-portlet-container {
  .tabs-portlet-head {
    .tabs-portlet-tab-headers {
      border-bottom: 0;
    }
    .tabs-portlet-actions {
      margin-left: 15px;
      padding: 5px;
    }
  }
}
</style>
